import React from 'react';
import FeatherIcon from 'feather-icons-react';

interface IngestionWarningsBannerProps {
  warnings: string[];
  dismissed: boolean;
  onDismiss: () => void;
}

/** AXISREF244: Warn when online form attachments could not be fetched at intake. */
export const IngestionWarningsBanner: React.FC<IngestionWarningsBannerProps> = ({
  warnings,
  dismissed,
  onDismiss,
}) => {
  if (dismissed || !warnings.length) {
    return null;
  }

  return (
    <div
      className="upload-error-banner"
      style={{
        backgroundColor: '#fff8e1',
        color: '#e65100',
        padding: '0.75rem 1rem',
        borderRadius: '4px',
        marginTop: '1rem',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.5rem',
      }}
    >
      <FeatherIcon icon="alert-triangle" size={16} />
      <div style={{ flex: 1 }}>
        {warnings.map((warning, idx) => (
          <div key={idx}>{warning}</div>
        ))}
      </div>
      <button
        onClick={onDismiss}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#e65100',
        }}
        title="Dismiss"
      >
        <FeatherIcon icon="x" size={14} />
      </button>
    </div>
  );
};
